import { ACTION_TYPES } from "../actions/types";
import dayjs from "dayjs";
import { REPORT_RANGES } from "../constants";
import { DEFAULT_RENDER_CONFIG, normalizeRenderConfig } from "../renderConfig";
import {
  decorateServicesWithDisplayNames,
  normalizeReportServiceLabels,
} from "../serviceDisplayNames";
import { normalizeArrivalRatesPerHourReports } from "../arrivalRates";

const initialState = {
  setupStatus: -1, // whether the app is setup or not. -1=not done yet, 0=failed, 1=success
  reportRange: REPORT_RANGES.RT,

  organizations: [],
  branches: [],

  // filter
  organizationId: "",
  branchId: "",
  dateRange: [],

  // settings
  hoursPerDay: 8,
  loading: false,
  workWeek: [1, 2, 3, 4, 5], // sunday=0, monday=1, tuesday=2, wednesday=3, thursday=4, friday=5, saturday=6
  showEmptyDataSets: 0, // 1=show , 0=hide,
  reportsData: [],
  reportSubscription: {}, //active subscription object either for creating a new one or editing
  reportTypes: [],
  services: [],
  servicesSubscriptions: [],
  users: [],
  reportRenderSetting: null,
  reportRenderConfig: DEFAULT_RENDER_CONFIG,
  savingReportRenderSetting: false,

  workDay: [
    "8 AM",
    "9 AM",
    "10 AM",
    "11 AM",
    "12 PM",
    "1 PM",
    "2 PM",
    "3 PM",
    "4 PM",
  ],
};

export default function reducerCase(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.GET_REPORTS_DATA:
      return {
        ...state,
        reportsData: normalizeReportServiceLabels(
          normalizeArrivalRatesPerHourReports(action.payload, state.hoursPerDay),
          state.services
        ),
      };
    case "GET_BRANCHES":
      return {
        ...state,
        branches: action.payload,
      };

    case "SET_DATE_RANGE":
      return {
        ...state,
        dateRange: action.payload,
      };

    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case ACTION_TYPES.UPDATE_APP_STATUS:
      return {
        ...state,
        appStatus: action.payload,
      };
    case "UPDATE_REPORT_RANGE":
      return {
        ...state,
        reportRange: action.payload,
      };

    case ACTION_TYPES.UPDATE_REPORT_DURATION:
      return {
        ...state,
        reportDuration: action.payload,
      };

    case "GET_ORGANIZATIONS":
      return {
        ...state,
        organizations: action.payload,
      };

    case "UPDATE_ORGANIZATION_ID":
      return {
        ...state,
        organizationId: action.payload,
      };

    case "UPDATE_BRANCH_ID":
      return {
        ...state,
        branchId: action.payload,
      };

    case ACTION_TYPES.GET_REPORT_TYPES:
      return {
        ...state,
        reportTypes: action.payload,
      };

    case ACTION_TYPES.SET_REPORT_RENDER_SETTING:
      return {
        ...state,
        reportRenderSetting: action.payload,
        reportRenderConfig: normalizeRenderConfig(action.payload?.renderConfig),
      };

    case ACTION_TYPES.SET_REPORT_RENDER_SETTING_SAVING:
      return {
        ...state,
        savingReportRenderSetting: action.payload,
      };

    case "GET_SERVICES": {
      const services = decorateServicesWithDisplayNames(action.payload);
      return {
        ...state,
        services,
        reportsData: normalizeReportServiceLabels(state.reportsData, services),
      };
    }

    case "GET_SERVICES_SUBSCRIPTIONS":
      return {
        ...state,
        servicesSubscriptions: action.payload,
      };

    case "GET_USERS":
      return {
        ...state,
        users: action.payload,
      };

    default:
      return state;
  }
}
